// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:768px){.popup[data-v-df4edd92]{width:540px}.popup .popup-content[data-v-df4edd92]{padding:48px}.popup .popup-footer[data-v-df4edd92]{height:70px}.popup .popup-btn[data-v-df4edd92]{line-height:32px;font-size:32px}}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
